import { render, staticRenderFns } from "./dc.select.vue?vue&type=template&id=6054409a&"
import script from "./dc.select.vue?vue&type=script&lang=js&"
export * from "./dc.select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports